import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

export interface RenameGroupDialogComponentData {
  groupName: string
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rename-group',
  template: `
    <h1 mat-dialog-title>Rename Group Name</h1>
    <div mat-dialog-content>
      <div class="sf-dialog-controls">
        <ejs-textbox
          placeholder="Group Name"
          floatLabelType="Auto"
          [(ngModel)]="groupName"
          maxlength="50"
          required
          name="groupName"
          #groupNameModel="ngModel"
          cssClass="e-outline full-width"
        ></ejs-textbox>
        <div *ngIf="groupNameModel.invalid && groupNameModel.touched" class="e-error">
          Value is required.
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button
        appButton
        accent
        [disabled]="!groupName || groupNameModel.invalid"
        (click)="renameGroupClick()"
      >
        <span>Rename</span>
      </button>
      <button appButton link mat-dialog-close type="button">
        <span>Cancel</span>
      </button>
    </div>
  `,
  styles: [
    `
      .sf-dialog-controls {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 10px;
        margin-bottom: 8px;
      }
      .full-width {
        width: 100%;
      }
      .e-error {
        color: #d32f2f;
        font-size: 13px;
        margin-left: 2px;
      }
    `,
  ],
})
export class RenameGroupDialogComponent {
  groupName: string

  constructor(
    public dialogRef: MatDialogRef<RenameGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RenameGroupDialogComponentData,
  ) {
    this.groupName = data.groupName
  }

  renameGroupClick() {
    if (this.groupName && this.groupName.trim().length > 0) {
      this.dialogRef.close(this.groupName)
    }
  }
}
